/* jshint ignore:start */
var seedWebApp;
(
    function () {

seedWebApp = angular.module('genesis_app', [
            'ngRoute',
            'seedWeb.controllers',            
            'seedWeb.services',
            'angularMoment',            
            'ngAria',
            'ngAnimate',
            'ngMaterial', //Angular Material
            'ui.bootstrap',
            'ui.codemirror',
            'angular-toasty',
            'minicolors',
            'angular.filter',
            'ngTagsInput',
            'ngFileUpload',
            'infinite-scroll',
            'angular-svg-round-progressbar',
            'auth0.auth0',
            'angular-jwt',
            'ngCookies',
            'ui.sortable',
            'angularCSS',
            'dndLists',
            //'ngMock',
        ]);
    }
)();

//VERSAO            DESCRICAO
//-----------------------------------------------------------
//2026.03.05 (qui)  ??
//2026.06.16 (ter)  Correção email enviado para logistica com link errado

seedWebApp.buildVersion = '?v=2026.06.16';
var seedWebControllers = angular.module('seedWeb.controllers', []);
var seedWebServices = angular.module('seedWeb.services', ['ngResource']);


//Para dropdown com PESQUISA
seedWebApp.directive('focusOn', function () {
    return function (scope, elem, attr) {
        scope.$on(attr.focusOn, function (e) {
            elem[0].focus();
        });
    };
});



seedWebApp.directive('format', ['$filter', function ($filter) {
    return {
        require: '?ngModel',
        link: function (scope, elem, attrs, ctrl) {
            if (!ctrl) return;

            ctrl.$formatters.unshift(function (a) {
                return $filter(attrs.format)(ctrl.$modelValue)
            });

            elem.bind('blur', function (event) {
                var plainNumber = elem.val().replace(/[^\d|\-+|\.+]/g, '');
                elem.val($filter(attrs.format)(plainNumber));
            });
        }
    };
}]);

seedWebApp.factory('httpSeedRequestInterceptor', ['$cookies', function ($cookies) {
    return {
        request: function (config) {
            config.headers.CompanyID = $cookies.get('company-id');
            return config;
        }
    };
}]);

seedWebApp.config(['$locationProvider', '$mdThemingProvider', '$httpProvider', 'jwtInterceptorProvider', 'angularAuth0Provider',
    function ($locationProvider, $mdThemingProvider, $httpProvider, jwtInterceptorProvider, angularAuth0Provider) {

    // We're annotating this function so that the `store` is injected correctly when this file is minified
        jwtInterceptorProvider.tokenGetter = ['$cookies', function ($cookies) {
            //console.log('tokenGetter ' + $cookies.get('token'));
            // Return the saved token
            return $cookies.get('token');
        }
    ];

    $httpProvider.interceptors.push('jwtInterceptor');
    $httpProvider.interceptors.push('httpSeedRequestInterceptor');


    //Thema Angular Material
    $mdThemingProvider.theme('default').primaryPalette('blue').accentPalette('orange');


    // ISO 8601 Date Pattern: YYYY-mm-ddThh:MM:ss
    var dateMatchPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
    var convertDates = function (obj) {
        for (var key in obj) {
            if (!obj.hasOwnProperty(key)) {
                continue;
            }

            var value = obj[key];
            var typeofValue = typeof (value);

            if (typeofValue === 'object') {
                // If it is an object, check within the object for dates.
                convertDates(value);
            } else if (typeofValue === 'string') {
                if (dateMatchPattern.test(value)) {
                    obj[key] = new Date(value);
                }
            }
        }
    };

    $httpProvider.defaults.transformResponse.push(function (data) {
        if (typeof (data) === 'object') {
            convertDates(data);
        }

        return data;
    });

    var redirect = 'https://' + location.host + '/Home/';      


    angularAuth0Provider.init({
        clientID: 'KXfOeTzgVer8tB45eNw3PQ5DOuOMS73P',
        domain: 'seed-genesis-apps.us.auth0.com',
        callbackURL: location.href,
        responseType: 'token id_token',
        redirectUri: redirect,
        scope: 'openid profile email',
    });

}]);

/* jshint ignore:end */
